module.exports = __webpack_public_path__ + "img/1584471123.88e7ba17.jpg";